import React, { useState, useEffect } from "react";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

function ShopDetail() {
    const [shopDetail, setShopDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const fetchApiData = async () => {
            const name = location.pathname.split("/").filter(Boolean).pop();
            const url = "api/shop-detail/" + name;
            const result = await fetchData(url);
            setLoading(false);
            console.log(result.data)
            if (result && result.data) {
                setShopDetail(result.data);
            }
        };
        fetchApiData();
    }, [location.pathname]);
   const shoptypeList = [
        { "value": "supplier", "label": "Supplier" },
        { "value": "technicians", "label": "Technicians" },
        { "value": "installer", "label": "Installer" },
        { "value": "retailer", "label": "Retailer" },
        { "value": "importer-exporter", "label": "Importer/Exporter" },
        { "value": "franchise-dealership", "label": "Franchise/Dealership" },
        { "value": "electrician", "label": "Electrician" },
        { "value": "mechanic", "label": "Mechanic" },
        { "value": "manufacturer", "label": "Manufacturer" }
    ]

    const ShopTypeName = (type) => {
        const typeObj = shoptypeList.find(t => t.value === type);
        return typeObj ? typeObj.label : type;
    }
    return (
        <div className="container py-5">
            {loading ? (
                <MainLoader />
            ) : (
                <>
                    <div className="">
                        {/* Modern Header */}
                        <div className="brand-banner py-5 px-3 text-center text-white mb-4">
                            <h1 className="display-4 fw-bold mb-2">Shop <span className="brand-name">Detail</span> </h1>
                            <p className="lead">Discover top-rated businesses, explore services, and find the right shop for your needs</p>

                        </div>
                    </div>
                    <div className="card p-4 border-0 shadow rounded-4">
                        <div className="row">
                            <div className="col-md-8 col-sm-12 col-12">
                                <div className="d-flex gap-2 flex-wrap">
                                    <h4 className="mb-3 text-primary">{shopDetail?.shop_name}</h4>
                                    {shopDetail?.is_verified !== 0 && (
                                        <p className="bg-success small px-2 py-1 text-white rounded">Verified</p>
                                    )}
                                </div>
                                <p>{shopDetail?.description}</p>
                                <div className="row g-4">
                                    {/* Pathname */}
                                    <InfoBlock icon="bi-link-45deg" label="Email" value={shopDetail?.email} />

                                    {/* Search */}
                                    <InfoBlock icon="bi-search" label="Contact" value={shopDetail?.phone} />

                                    {/* Hash */}
                                    {/* <InfoBlock icon="bi-geo-alt" label="Address" value={shopDetail?.address} /> */}
                                    <InfoBlock icon="bi-clock" label="Opening Hours" value={shopDetail?.opening_hours} />
                                    <div className="col-md-12 d-flex align-items-center mb-3">
                                        {/* Icon */}
                                        <div
                                            className="me-3 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                            style={{ width: "50px", height: "50px" }}
                                        >
                                            <i className="bi bi-geo-alt fs-4"></i>
                                        </div>

                                        {/* Text */}
                                        <div className="flex-grow-1">
                                            <h6 className="mb-0">Address</h6>
                                            <p className="mb-0 text-muted text-break">
                                                {shopDetail?.address}
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-4 col-12 col-sm-12">
                                <img src={shopDetail.media[0]?.original_url} style={{ height: '16em', objectFit: 'contain' }} className="w-100" />
                            </div>
                        </div>


                        {/* Shop API Detail Section */}
                        <div className="mt-5">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">City:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.city?.name}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">State:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.state?.name}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">Country:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.country?.name}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">Shop Category:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.category?.title}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">Business Type:</strong>{" "}
                                        <span className="text-muted">{ShopTypeName(shopDetail?.category_of_shop)}</span>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="p-3 bg-light rounded border">
                                        <strong className="text-capitalize">Website URL:</strong>{" "}
                                        <span className="text-muted">{shopDetail?.website_url}</span>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-5">
                                    <div dangerouslySetInnerHTML={{ __html: shopDetail?.long_description }}></div>
                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

// Reusable InfoBlock component for router data
const InfoBlock = ({ icon, label, value }) => (
    <div className="col-md-6 d-flex align-items-center" >
        <div
            className="me-3 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
            style={{ width: "50px", height: "50px" }}
        >
            <i className={`bi ${icon} fs-4`}></i>
        </div>
        <div>
            <h6 className="mb-0">{label}</h6>
            <p className="mb-0 text-muted">{value}</p>
        </div>
    </div>
);

export default ShopDetail;
